

export const formatters = {
  formatDate: (dateString: string | null | undefined): string => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR');
    } catch {
      return 'Data inválida';
    }
  },

  formatCurrency: (value: number | null | undefined): string => {
    if (value === null || value === undefined) return 'N/A';
    try {
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch {
      return 'R$ 0,00';
    }
  },

  formatNumber: (value: number | null | undefined): string => {
    if (value === null || value === undefined) return 'N/A';
    try {
      return value.toLocaleString('pt-BR');
    } catch {
      return '0';
    }
  },

  formatDecimal: (value: number | null | undefined): string => {
    if (value === null || value === undefined) return 'N/A';
    try {
      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch {
      return '0,00';
    }
  },
};
